 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"d42d547b668167b9bab913bfe74d2664308dde41","3":"875ea9739805bb53fa356a6c6aa8caa3ccd69097","4":"abe0b775813f5e1153e5e07207326866f6e8aa68","5":"f167da58bd993678e2d7774ce148eba01b68a92a","6":"d90101e8d258335486718cc7573fe72396b55460","7":"5e1085ff354e3bb6daefedf5e48fe6e4b1d8e564","8":"0cc20c5e5e5f1913c7b3dee64f6a383ed3d42411","9":"771d6599373c657452cbf1b4a7e550360826e426","10":"8e5974099a4f8437c03b235ee630755b4020c76c","12":"06f6b0c0","14":"c2ef2995","15":"component---src-pages-404-js","16":"component---src-pages-cases-2-cents-js","17":"component---src-pages-cases-cartovera-js","18":"component---src-pages-cases-chernomorsk-js","19":"component---src-pages-cases-city-portal-js","20":"component---src-pages-cases-crm-sap-integration-js","21":"component---src-pages-cases-design-js","22":"component---src-pages-cases-diasoft-js","23":"component---src-pages-cases-fcteam-js","24":"component---src-pages-cases-gud-job-js","25":"component---src-pages-cases-ilich-realty-js","26":"component---src-pages-cases-ingo-js","27":"component---src-pages-cases-iot-js","28":"component---src-pages-cases-js","29":"component---src-pages-cases-karpatska-chaika-js","30":"component---src-pages-cases-pickup-sport-js","31":"component---src-pages-cases-rzd-roads-js","32":"component---src-pages-cases-service-doc-js","33":"component---src-pages-cases-social-app-js","34":"component---src-pages-cases-utility-management-software-js","35":"component---src-pages-cases-video-conference-js","36":"component---src-pages-cases-videoconftool-js","37":"component---src-pages-cases-webrtc-js","38":"component---src-pages-cases-wikigrads-js","39":"component---src-pages-company-js","40":"component---src-pages-contact-js","41":"component---src-pages-estimate-js","42":"component---src-pages-expertise-cloud-solutions-js","43":"component---src-pages-expertise-cross-platform-js","44":"component---src-pages-expertise-internet-of-things-js","45":"component---src-pages-expertise-js","46":"component---src-pages-expertise-medical-app-development-services-js","47":"component---src-pages-expertise-rtc-js","48":"component---src-pages-expertise-uiuxdesign-js","49":"component---src-pages-how-we-work-js","50":"component---src-pages-index-js","51":"component---src-pages-services-dedicatedteam-js","52":"component---src-pages-services-js","53":"component---src-pages-services-mobile-js","54":"component---src-pages-services-qa-js","55":"component---src-pages-services-startups-js","56":"component---src-pages-services-uiuxdesign-js","57":"component---src-pages-services-web-js","58":"component---src-pages-technology-js","59":"e8433949"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"bc6922d4c0bc93e9c64c","2":"255770167ac35df8f2a4","3":"8acc5bc049f7e47d3a59","4":"97399f82fc6132b0dc20","5":"5bc1dadb4498e674c642","6":"f0d83251b22c3dc243b0","7":"9ecc17a7eeb8809fbec4","8":"63bcb59425d2dc863531","9":"a6782abce38adf030bcd","10":"e809142fdbd25f702c70","12":"9a7e623dd99662f429d6","14":"4d3b77c6ab2ad9caf35a","15":"f993b3ef35cf4926bde9","16":"93b98745c385468faac9","17":"05301d979996feb555c1","18":"9c54ada8807afc3a6a2d","19":"b5999f2ec54bc0363a5f","20":"71b8078fa3efa97f63de","21":"bffceca3829fec1ae93e","22":"9ea7b3d0c9142dfc2b0a","23":"3370a2b8ff7d7e55744a","24":"3d27c4a231c70aebf401","25":"3c5b602157d58f0185e8","26":"ffa98674880b5b3a3e48","27":"e69d7bd6aafeda1be833","28":"960fc3fe7b12fdfa2a27","29":"53f420efba33b0877dec","30":"eadf8891e57349a72e1a","31":"b688f7d07d367edde32a","32":"be10fa000c837eb82d02","33":"3ae00b1426fd92ab23ff","34":"d6180180757871f05cb9","35":"42eed0bdfc35219d6c2b","36":"1dc3046b098f188fcd95","37":"9c9aca175a3aae11d404","38":"cc443014c80f50ebf04a","39":"daf035542936e65fd1e4","40":"3554b7d7ff1498c0191e","41":"5594536891ed6355c13f","42":"efd181b0369b2832a7e3","43":"91e5a2f961100b19704c","44":"d563aab49c1ec3c77a1b","45":"8525b1160cf58c8ebbb4","46":"e1152cb6408f8609c4ce","47":"82f882916d1d1f5e2e9f","48":"c16c6aa8d31497e70ee2","49":"8973c46015962507fe14","50":"cf17ddb381ca1d49ea02","51":"e200a4924ff48507e933","52":"b15200f723410ee25586","53":"643b9eb4151740b47c1d","54":"016e3debec01cbf2b1fe","55":"c6bb930769f7c16d7620","56":"172d40152c710257450e","57":"1a2930112200ce0fbb6b","58":"237c7a7c9a032e5a5a44","59":"2318746a8fa55714b8bc","62":"17b46b6feb8082e5512d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"d42d547b668167b9bab913bfe74d2664308dde41","3":"875ea9739805bb53fa356a6c6aa8caa3ccd69097","4":"abe0b775813f5e1153e5e07207326866f6e8aa68","5":"f167da58bd993678e2d7774ce148eba01b68a92a","6":"d90101e8d258335486718cc7573fe72396b55460","7":"5e1085ff354e3bb6daefedf5e48fe6e4b1d8e564","8":"0cc20c5e5e5f1913c7b3dee64f6a383ed3d42411","9":"771d6599373c657452cbf1b4a7e550360826e426","10":"8e5974099a4f8437c03b235ee630755b4020c76c","12":"06f6b0c0","14":"c2ef2995","15":"component---src-pages-404-js","16":"component---src-pages-cases-2-cents-js","17":"component---src-pages-cases-cartovera-js","18":"component---src-pages-cases-chernomorsk-js","19":"component---src-pages-cases-city-portal-js","20":"component---src-pages-cases-crm-sap-integration-js","21":"component---src-pages-cases-design-js","22":"component---src-pages-cases-diasoft-js","23":"component---src-pages-cases-fcteam-js","24":"component---src-pages-cases-gud-job-js","25":"component---src-pages-cases-ilich-realty-js","26":"component---src-pages-cases-ingo-js","27":"component---src-pages-cases-iot-js","28":"component---src-pages-cases-js","29":"component---src-pages-cases-karpatska-chaika-js","30":"component---src-pages-cases-pickup-sport-js","31":"component---src-pages-cases-rzd-roads-js","32":"component---src-pages-cases-service-doc-js","33":"component---src-pages-cases-social-app-js","34":"component---src-pages-cases-utility-management-software-js","35":"component---src-pages-cases-video-conference-js","36":"component---src-pages-cases-videoconftool-js","37":"component---src-pages-cases-webrtc-js","38":"component---src-pages-cases-wikigrads-js","39":"component---src-pages-company-js","40":"component---src-pages-contact-js","41":"component---src-pages-estimate-js","42":"component---src-pages-expertise-cloud-solutions-js","43":"component---src-pages-expertise-cross-platform-js","44":"component---src-pages-expertise-internet-of-things-js","45":"component---src-pages-expertise-js","46":"component---src-pages-expertise-medical-app-development-services-js","47":"component---src-pages-expertise-rtc-js","48":"component---src-pages-expertise-uiuxdesign-js","49":"component---src-pages-how-we-work-js","50":"component---src-pages-index-js","51":"component---src-pages-services-dedicatedteam-js","52":"component---src-pages-services-js","53":"component---src-pages-services-mobile-js","54":"component---src-pages-services-qa-js","55":"component---src-pages-services-startups-js","56":"component---src-pages-services-uiuxdesign-js","57":"component---src-pages-services-web-js","58":"component---src-pages-technology-js","59":"e8433949"}[chunkId]||chunkId) + "." + {"0":"8d3ecf9e453851df4617","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
